import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { NewsletterForm } from "./NewsletterForm";

export const NewsletterPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (
      localStorage.getItem("newsletterPopupShown") ||
      localStorage.getItem("newsletterSubscribed")
    ) {
      return undefined;
    }
    let shown = false;
    let timer;

    const cleanup = () => {
      document.removeEventListener("mouseout", onMouseOut);
      clearTimeout(timer);
      ["touchstart", "scroll", "click"].forEach((ev) =>
        window.removeEventListener(ev, resetTimer),
      );
    };
    const show = () => {
      if (shown) return;
      shown = true;
      localStorage.setItem("newsletterPopupShown", "1");
      setOpen(true);
      cleanup();
    };
    function onMouseOut(e) {
      if (!e.relatedTarget && e.clientY <= 8) show();
    }
    function resetTimer() {
      clearTimeout(timer);
      timer = setTimeout(show, 30000);
    }

    if (window.matchMedia("(pointer: coarse)").matches) {
      resetTimer();
      ["touchstart", "scroll", "click"].forEach((ev) =>
        window.addEventListener(ev, resetTimer, { passive: true }),
      );
    } else {
      document.addEventListener("mouseout", onMouseOut);
    }
    return cleanup;
  }, []);

  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = "hidden";
    const onEsc = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onEsc);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onEsc);
    };
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[80] flex items-end justify-center p-4 sm:items-center">
          <motion.div
            data-testid="newsletter-popup-backdrop"
            className="absolute inset-0 bg-choc-deep/60 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
          />
          <motion.div
            role="dialog"
            aria-modal="true"
            data-testid="newsletter-popup"
            className="relative w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl"
            initial={{ opacity: 0, y: 48, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 32, scale: 0.97 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="h-1.5 w-full bg-brick" />
            <div className="p-8">
              <button
                data-testid="newsletter-popup-close-button"
                onClick={() => setOpen(false)}
                aria-label="Zamknij"
                className="absolute right-5 top-5 rounded-full p-1.5 text-clay transition-colors duration-300 hover:bg-cream hover:text-choc"
              >
                <X className="h-5 w-5" />
              </button>
              <span className="text-xs font-semibold uppercase tracking-[0.28em] text-brick">
                Darmowa konsultacja
              </span>
              <h3 className="mt-3 max-w-xs font-display text-2xl font-semibold leading-snug tracking-tight sm:text-3xl">
                Odbierz darmową konsultację
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-clay sm:text-base">
                Zostaw e-mail — odezwę się z darmową konsultacją i informacjami
                o nowościach dla Twojego lokalu.
              </p>
              <div className="mt-6">
                <NewsletterForm idPrefix="newsletter-popup" />
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
